/* Instagram embeds — loads Instagram's embed.js once and (re)processes
   any blockquotes in this element, including after theme-editor reloads. */

class InstagramEmbeds extends HTMLElement {
  connectedCallback() {
    InstagramEmbeds.loadScript().then(() => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    });
  }

  static loadScript() {
    if (window.instgrm && window.instgrm.Embeds) {
      return Promise.resolve();
    }
    if (InstagramEmbeds._scriptPromise) {
      return InstagramEmbeds._scriptPromise;
    }
    InstagramEmbeds._scriptPromise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = resolve;
      document.body.appendChild(script);
    });
    return InstagramEmbeds._scriptPromise;
  }
}

customElements.define('instagram-embeds', InstagramEmbeds);
